<template>
  <div class="kt-portlet kt-portlet--mobile">
    <div class="kt-form">
      <!--begin::Form-->
      <form class="kt-form" ref="form" @submit.prevent="formSubmit($event)">
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="kt-font-brand flaticon-home"></i>
            </span>
            <h3 class="kt-portlet__head-title">
              {{ this.$route.meta.breadcrumb }}
            </h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <div class="kt-section kt-section--first">
            <div class="row">
              <!-- begin: รหัสร้านค้า -->
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
                <div class="form-group">
                  <label class="label">รหัสร้านค้า:  </label>
                  <span class="form-control-plaintext"   v-if="AgentType=='AGENT'">{{
                    dtsCustCode
                  }}</span>
                   <span class="form-control-plaintext" v-if="AgentType=='SUB_AGENT'">{{
                    dtsSubAgentCode
                  }}</span>


                </div>
              </div>
              <!-- end: รหัสร้านค้า -->
              <!-- begin: ชื่อร้านค้า -->
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
                <div class="form-group">
                  <label class="label">ชื่อร้านค้า:</label>
                  <span class="form-control-plaintext"  v-if="AgentType=='AGENT'">{{
                    dtsCustomerName
                  }}</span>
                  <span class="form-control-plaintext" v-if="AgentType=='SUB_AGENT'">{{
                    dtsSubAgentCustomerName
                  }}</span>
                </div>
              </div>
              <!-- end: ชื่อร้านค้า -->
              <!-- begin: ชื่อร้านค้า 2 -->
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
                <div class="form-group">
                  <label class="label">ชื่อร้านค้า 2:</label>
                  <span class="form-control-plaintext"  v-if="AgentType=='AGENT'">{{
                    dtsCustomerName2
                  }}</span>
                   <span class="form-control-plaintext" v-if="AgentType=='SUB_AGENT'">{{
                    dtsSubAgentCustomerName2
                  }}</span>
                </div>
              </div>
              <!-- end: ชื่อร้านค้า 2 -->
              <!-- begin: ประเภทร้านค้า -->
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
                <div class="form-group">
                  <label class="label">ประเภทร้านค้า:</label>
                  <span class="form-control-plaintext">{{
                    dtsCustomerType
                  }}</span>
                </div>
              </div>
              <!-- end: ประเภทร้านค้า -->
              <!-- begin: ผู้ร้องขอแก้ไข -->
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
                <div class="form-group">
                  <label class="label">ผู้ร้องขอแก้ไข:</label>
                  <span class="form-control-plaintext">{{ dtsUserName }}</span>
                </div>
              </div>
              <!-- end: ผู้ร้องขอแก้ไข -->
              <!-- begin: อำเภอ -->
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
                <div class="form-group">
                  <label class="label">อำเภอ:</label>
                  <span class="form-control-plaintext">{{ dtsAmpher }}</span>
                </div>
              </div>
              <!-- end: อำเภอ -->
              <!-- begin: จังหวัด -->
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
                <div class="form-group">
                  <label class="label">จังหวัด:</label>
                  <span class="form-control-plaintext">{{ dtsProvince }}</span>
                </div>
              </div>
              <!-- end: จังหวัด -->

              <!-- begin:สถานะ -->
              <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <div class="form-group">
                  <label class="label-required">สถานะ:</label>
                  <span class="form-control-plaintext">{{ dtsStatus }}</span>
                </div>
              </div>
              <!-- end: สถานะ -->

              <!-- begin: พื้นที่ -->
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
                <div class="form-group">
                  <label class="label">พื้นที่กิจกรรม: </label>
                  <GmapMap
                    :center="{ lat: dtsNLat, lng: dtsNLng }"
                    :zoom="12"
                    :clickable="true"
                    style="width: 500px; height: 300px"
                  >
                    <gmap-marker
                      :key="index"
                      v-for="(m, index) in dtsMarkers"
                      :position="m.positionN"
                      :draggable="false"
                      :clickable="true"
                      icon="http://maps.google.com/mapfiles/ms/icons/red-dot.png"
                      title="พื้นที่ใหม่"
                    >
                    </gmap-marker>
                    <gmap-marker
                      :key="index"
                      v-for="(m, index) in dtsMarkers"
                      :position="m.positionO"
                      :draggable="false"
                      :clickable="true"
                      icon="http://maps.google.com/mapfiles/ms/icons/yellow-dot.png"
                      title="พื้นที่เดิม"
                    >
                    </gmap-marker>
                  </GmapMap>
                  <label class="label"
                    ><span style="color:red">สีแดง:พื้นที่ใหม่</span> ,
                    <span style="color:#DAA520"
                      >สีเหลือง:พื้นที่เดิม</span
                    ></label
                  >
                </div>
              </div>
              <!-- end: พื้นที่ -->
            </div>
            <!-- <div class="row">
                          <div class="col-xl-12">
                            <h4 class="kt-section__title">ประวัติการอนุมัติ</h4>
                            <div class="row">
                              <div class="col-lg-12 table-responsive">
                                <table
                                  class="table-sm table-striped- table-bordered table-hover table-checkable"
                                  id="table-history"
                                >
                                  <thead>
                                    <tr>
                                      <th>วันที่</th>
                                      <th>ผู้อนุมัติ</th>
                                      <th>ลำดับ</th>
                                      <th>สถานะ</th>
                                      <th>หมายเหตุ</th>
                                    </tr>
                                  </thead>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div> -->
          </div>
        </div>
        <div class="kt-portlet__foot">
          <button
            type="button"
            class="btn btn-secondary"
            data-dismiss="modal"
            @click="$router.go(-1)"
          >
            <i class="la la-close"></i> ย้อนกลับ
          </button>
          <button
            type="button"
            class="btn btn-success"
            @click="onApprove($event)"
            v-if="dtsIsApprove === false"
          >
            <i class="la la-check"></i> อนุมัติ
          </button>
          <button
            type="button"
            class="btn btn-danger"
            @click="onReject($event)"
            v-if="dtsIsApprove === false"
          >
            <i class="la la-close"></i> ไม่อนุมัติ
          </button>
        </div>
      </form>
      <!--end::Form-->
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Vue from "vue";
import * as VueGoogleMaps from "vue2-google-maps";
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyCeGao-PkONmiyVksl46W_OUHt854bcrqE",
    libraries: "places",

    //// If you want to set the version, you can do so:
    // v: '3.26',
  },
});

export default {
  components: {},
  data: function() {
    var self = this;

    return {
      AgentType  : "AGENT",
      dtsCustomerChangeRequestId: null,
      dtsCustCode: null,
      dtsCustomerName: null,
      dtsCustomerName2: null,
      dtsCustomerType: null,
      dtsUserName: null,
      dtsAmpher: null,
      dtsProvince: null,
      dtsOldLatitude: null,
      dtsNewLatitude: null,
      dtsOldLongitude: null,
      dtsNewLongitude: null,
      dtsStatus: null,
      dtsIsApprove: true,
      dtsNLat: null,
      dtsNLng: null,
      dtsOLat: null,
      dtsOLng: null,
      dtsMarkers: [],

      dtsSubAgentCode : null,
      dtsSubAgentCustCode : null,
      dtsSubAgentCustomerName: null,
      dtsSubAgentCustomerName2: null 
    };
  },

  methods: {
    onApprove: function(e) {
      e.preventDefault();
      let self = this;
      let router = this.$router;
      Swal.fire({
        title: "คำสั่งอนุมัติแก้ไขข้อมูลร้านค้า",
        type: "warning",
        html: "กรุณายืนยันอนุมัติแก้ไขข้อมูลร้านค้า <strong>",
        inputValue: 0,
        inputPlaceholder: "อนุมัติแก้ไขข้อมูลร้านค้า",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังอนุมัติข้อมูล กรุณารอสักครู่...",
          });

          //UpdateBorrowProduct
          if (self.ubpIsEdit) {
            self.formSubmit();
          }

          axios
            .get("/Api/ShopChangeRequest/" + this.$route.params.id + "/Approve")
            .then(function(response) {
              if (response.data.status) {
                Swal.fire("สำเร็จ", response.data.message, "success").then(
                  function() {
                    router.go(-1), self.$parent.reloadDataTable(false);
                    //router.push({ path: `/Borrow` });
                  }
                );
              } else {
                Swal.fire(
                  "เกิดข้อผิดพลาด",
                  error.response.data.message,
                  "error"
                );
              }
            })
            .catch(function(error) {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            })
            .then(function() {
              // always executed
              KTApp.unblockPage();
            });
        }
      });
    },
    onReject: function(e) {
      e.preventDefault();
      let self = this;
      let router = this.$router;
      Swal.fire({
        title: "คำสั่งไม่อนุมัติแก้ไขข้อมูลร้านค้า",
        type: "warning",
        html: "กรุณายืนยันไม่อนุมัติแก้ไขข้อมูลร้านค้า <strong>",
        // input: "text",
        // inputAttributes: {
        //   autocapitalize: "off",
        // },
        // // inputValue: 0,
        // inputPlaceholder: "กรุณาระบุหมายเหตุผลไม่อนุมัติแก้ไขข้อมูลร้านค้า",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
        // inputValidator: (value) => {
        //   return new Promise((resolve) => {
        //     if (value === "") {
        //       resolve("กรุณาระบุหมายเหตุผลไม่อนุมัติแก้ไขข้อมูลร้านค้า");
        //     } else {
        //       resolve();
        //     }
        //   });
        // },
      }).then((result) => {
        if (result.value) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังบันทึกข้อมูล กรุณารอสักครู่...",
          });
          axios({
            method: "post",
            url: "/Api/ShopChangeRequest/Reject",
            data: {
              Id: this.$route.params.id,
              Remark: result.value,
            },
          })
            // .post("/Api/ProductLoan/" + this.$route.params.id + "/Reject",)
            .then(function(response) {
              if (response.data.status) {
                Swal.fire("สำเร็จ", response.data.message, "success").then(
                  function() {
                    router.go(-1), self.$parent.reloadDataTable(false);
                    //router.push({ path: `/Borrow` });
                  }
                );
              } else {
                Swal.fire(
                  "เกิดข้อผิดพลาด",
                  error.response.data.message,
                  "error"
                );
              }
            })
            .catch(function(error) {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            })
            .then(function() {
              // always executed
              KTApp.unblockPage();
            });
        } else {
        }
      });
    },
  },
  computed: {},
  async mounted() {
    let self = this;
    let router = this.$router;

    KTApp.blockPage({
      opacity: 0.05,
      message: "กำลังดึงข้อมูล กรุณารอสักครู่...",
    });

    var arrows;
    if (KTUtil.isRTL()) {
      arrows = {
        leftArrow: '<i class="la la-angle-right"></i>',
        rightArrow: '<i class="la la-angle-left"></i>',
      };
    } else {
      arrows = {
        leftArrow: '<i class="la la-angle-left"></i>',
        rightArrow: '<i class="la la-angle-right"></i>',
      };
    }
    axios
      .get("/Api/ShopChangeRequest/" + this.$route.params.id)
      .then(function(response) {
        if (response.status == 200) {
          if (response.data != null) {
            self.AgentType  = (response.data.subAgentShopCode !=null && response.data.subAgentShopCode!="") ? "SUB_AGENT" : "AGENT" ,
              (self.dtsCustomerChangeRequestId = response.data.dtsCustomerChangeRequestId),
              (self.dtsCustCode = response.data.custCode),
              (self.dtsCustomerName = response.data.customerName),
              (self.dtsCustomerName2 = response.data.customerName2),
              (self.dtsCustomerType = response.data.shopTypeName),
              (self.dtsUserName = response.data.employeeFullName),
              (self.dtsAmpher = response.data.ampherName),
              (self.dtsProvince = response.data.provinceName),
              (self.dtsOldLatitude = response.data.oldLatitude),
              (self.dtsNewLatitude = response.data.newLatitude),
              (self.dtsOldLongitude = response.data.oldLongitude),
              (self.dtsNewLongitude = response.data.newLongitude),
              (self.dtsStatus = response.data.statusValue),
              (self.dtsIsApprove = response.data.isEnd);
            self.dtsNLat = parseFloat(response.data.newLatitude);
            self.dtsNLng = parseFloat(response.data.newLongitude);
            self.dtsOLat = parseFloat(response.data.oldLatitude);
            self.dtsOLng = parseFloat(response.data.oldLongitude);
            self.dtsMarkers = [
              {
                positionN: { lat: self.dtsNLat, lng: self.dtsNLng },
                positionO: { lat: self.dtsOLat, lng: self.dtsOLng },
              },
            ];
            
            self.dtsSubAgentCode= response.data.subAgentCode;
            self.dtsSubAgentCustCode = response.data.subAgentShopCode;
            self.dtsSubAgentCustomerName= response.data.subAgentShopName;
            self.dtsSubAgentCustomerName2=response.data.subAgentShopName2;
             
 
          }
        } else {
          Swal.fire(
            "เกิดข้อผิดพลาด",
            "ไม่พบข้อมูลการสั่งซื้อที่คุณเลือก",
            "warning"
          );
          router.go(-1);
        }
      })
      .catch(function(error) {
        Swal.fire(
          "เกิดข้อผิดพลาด",
          "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลการสั่งซื้อได้ในขณะนี้",
          "error"
        );
        router.go(-1);
      })
      .then(function() {
        // always executed

        KTApp.unblockPage();
      });
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// App/Components/Master/ShopChangeRequest/DetailShopChangeRequest.vue